// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__GZGrb","dateRangeLabel":"style_dateRangeLabel__Uwhf8"};